// Annual-accounts disclosures (no).
window.PlummeI18n.register('no', {
  'clo.comparativeFigures': 'Sammenligningstall',
  'clo.comparativeFiguresHelp': 'Tall fra forrige år fylles ut automatisk. Ved første år i Plumme kan de korrigeres mot godkjent årsregnskap.',
  'clo.offBalanceTitle': 'Garantier, pant og andre forpliktelser',
  'clo.addObligation': 'Legg til forpliktelse',
  'clo.newObligation': 'Ny forpliktelse',
  'clo.customNotes': 'Egendefinerte noter',
  'clo.noteTitle': 'Notetittel',
  'clo.noteText': 'Notetekst',
  'clo.addCustomNote': 'Legg til note',
  'clo.newNote': 'Ny note',
  'clo.newNoteHelp': 'Beskriv forholdet som skal opplyses.',
  'clo.noteOverviewTitle': 'Noteoversikt',
  'clo.noteOverviewHelp': 'Plumme foreslår noter fra bokførte signaler. Kontroller alltid vurderingen og fyll inn fakta som ikke finnes i regnskapet.',
  'clo.applyRelevantNotes': 'Aktiver relevante noter',
  'clo.standardComments': 'Standardkommentarer',
  'clo.noteComment': 'Kommentar til noten',
  'clo.noteAmount': 'Beløp som skal opplyses',
  'clo.securedDebtAmount': 'Gjeld sikret med pant',
  'clo.debtAfterFiveYears': 'Forfall etter fem år',
  'clo.noteStatus.applicable': 'Skal med',
  'clo.noteStatus.not_applicable': 'Ikke relevant',
  'clo.noteStatus.unknown': 'Må vurderes',
  'clo.noteStatus.review_required': 'Krever gjennomgang',
  'clo.noteReason.mandatory_note': 'Obligatorisk vurdering for denne årsregnskapsprofilen.',
  'clo.noteReason.ledger_or_registry_signal': 'Foreslått fra bokføring eller registrerte selskapsopplysninger.',
  'clo.noteReason.user_selected': 'Aktivert og skal kontrolleres før lagring.',
  'clo.noteReason.reviewed_not_applicable': 'Markert som ikke relevant etter gjennomgang.',
  'clo.noteReason.missing_fact_review': 'Plumme mangler fakta som avgjør om noten er relevant.',
  'clo.noteReason.unsupported_annual_note_scope': 'Foretak eller regelverk er utenfor den støttede noteprofilen.',
  'clo.noteCatalog.accountingPolicies': 'Regnskapsprinsipper',
  'clo.noteCatalog.goingConcern': 'Usikkerhet om fortsatt drift',
  'clo.noteCatalog.workYears': 'Antall årsverk',
  'clo.noteCatalog.payrollCosts': 'Lønnskostnader',
  'clo.noteCatalog.fixedAssets': 'Anleggsmidler',
  'clo.noteCatalog.groupAssociates': 'Konsern og tilknyttet selskap',
  'clo.noteCatalog.longTermReceivables': 'Langsiktige fordringer',
  'clo.noteCatalog.relatedPartyLoans': 'Lån og sikkerhet til ledelse, styre, aksjeeiere og nærstående',
  'clo.noteCatalog.fairValueInstruments': 'Virkelig verdi av finansielle instrumenter',
  'clo.noteCatalog.sharesTreasury': 'Aksjer, aksjeeiere og egne aksjer',
  'clo.noteCatalog.longTermDebt': 'Langsiktig gjeld, pant og løpetid',
  'clo.noteCatalog.additionalInformation': 'Opplysninger utover minimumskravene',
  'clo.notePreset.payrollReconciled': 'Lønnskostnadene er avstemt mot bokført lønn og arbeidsgiveravgift.',
  'clo.notePreset.noExecutiveCompensation': 'Det er ikke utbetalt særskilt godtgjørelse til daglig leder eller styret.',
  'clo.notePreset.noConsolidatedAccounts': 'Selskapet benytter unntaket fra å utarbeide konsernregnskap. Forutsetningene er kontrollert.',
  'clo.notePreset.costMethod': 'Investeringer i datterselskap og tilknyttet selskap er vurdert etter kostmetoden.',
  'clo.notePreset.receivableTermsReviewed': 'Langsiktige fordringer og avtalte forfall er kontrollert mot underliggende avtaler.',
  'clo.notePreset.relatedPartyTermsReviewed': 'Lån og sikkerhetsstillelser til nærstående er kontrollert mot avtaler og aksjeeierbok.',
  'clo.notePreset.fairValueBasisReviewed': 'Verdsettelsesmetode og grunnlaget for virkelig verdi er kontrollert og dokumentert.',
  'clo.notePreset.noTreasuryShares': 'Selskapet eide ingen egne aksjer ved utgangen av regnskapsåret.',
  'clo.notePreset.noCollateral': 'Det er ikke stilt pant eller annen sikkerhet for langsiktig gjeld.',
  'clo.notePreset.noDebtAfterFiveYears': 'Ingen del av den langsiktige gjelden forfaller senere enn fem år etter balansedagen.',
  'clo.noteSuggestion.payroll': 'Bokførte lønnskostnader er identifisert. Beløp og sammensetning må avstemmes før innsending.',
  'clo.noteSuggestion.group': 'Konsernforhold er identifisert. Konsernregnskapsplikt, unntak og valgt vurderingsmetode må kontrolleres.',
  'clo.noteSuggestion.receivables': 'Bokføringen viser langsiktige fordringer. Vilkår og forfall må kontrolleres mot avtalene.',
  'clo.noteSuggestion.relatedParty': 'Bokføringen kan inneholde lån eller sikkerhet til nærstående. Motpart, vilkår og beløp må kontrolleres.',
  'clo.noteSuggestion.fairValue': 'Bokføringen kan inneholde finansielle instrumenter vurdert til virkelig verdi. Metode og grunnlag må dokumenteres.',
  'clo.noteSuggestion.shares': 'Aksjeeieropplysningene må avstemmes mot aksjeeierboken. Eventuelle egne aksjer må opplyses særskilt.',
  'clo.noteSuggestion.debt': 'Bokføringen viser langsiktig gjeld. Pant og beløp med forfall etter fem år må bekreftes.',
  'clo.annualIssue.shares_disclosure_review': 'Aksjer, aksjeeiere og egne aksjer må kontrolleres og kommenteres.',
  'clo.annualIssue.note_disclosures_review': 'Aktiverte noter mangler en kontrollert kommentar.',
  'clo.invalidAnnualNoteDisclosures': 'Noteopplysningene er ugyldige.',
  'clo.invalidAnnualNoteAmount': 'Et beløp i noteopplysningene er ugyldig.',
});
